"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var h = require("./../../utils/createElement").h;
var React = tslib_1.__importStar(require("react"));
var Option_1 = tslib_1.__importDefault(require("./Option"));
var Dropdown_1 = tslib_1.__importDefault(require("../Dropdown"));
var Menu_1 = tslib_1.__importDefault(require("../Menu"));
var Input_1 = tslib_1.__importDefault(require("../Input"));
var helper_1 = require("../../utils/helper");
var theme_1 = require("../../utils/theme");
var instanceId_1 = require("../../utils/instanceId");
var context_1 = require("./context");
var locale_1 = require("../../common/locale");
var children_1 = require("../../utils/children");
var OptionElementType = (h(Option_1.default, null)).type;
var Select = (function (_super) {
    tslib_1.__extends(Select, _super);
    function Select() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.searchInputRef = React.createRef();
        _this.dropdownRef = React.createRef();
        _this.arrowRef = React.createRef();
        _this.menuRef = React.createRef();
        _this.id = instanceId_1.createGlobalInstanceId('Select');
        _this.menuId = _this.id + "-menu";
        _this.isClickSelect = false;
        _this.state = {
            currentValue: _this.getInitValue(),
            visible: false,
            searchValue: '',
            isSearchFocus: false,
        };
        _this.setSearchValue = function (value) {
            if (value === _this.state.searchValue) {
                return;
            }
            var onSearch = _this.props.onSearch;
            _this.setState({ searchValue: value }, function () {
                if (onSearch) {
                    onSearch(value);
                }
                _this.updateDropContentMetric();
                _this.scrollToSelected();
            });
        };
        _this.setCurrentValue = function (value, cb) {
            var onChange = _this.props.onChange;
            _this.setState({
                currentValue: value,
            }, function () {
                onChange(value);
                cb === null || cb === void 0 ? void 0 : cb();
            });
        };
        _this.updateDropContentMetric = function () {
            setTimeout(function () {
                var _a;
                (_a = _this.dropdownRef.current) === null || _a === void 0 ? void 0 : _a.refreshDropContentMetric();
            }, 0);
        };
        _this.handleSelectClick = function (event) {
            var _a = _this.props, showSearch = _a.showSearch, isMultiple = _a.isMultiple, searchPlacement = _a.searchPlacement;
            if (!showSearch && !isMultiple || event.target === _this.arrowRef.current) {
                return;
            }
            _this.isClickSelect = true;
            if (showSearch && searchPlacement === 'select') {
                _this.focusSearchInput();
            }
        };
        _this.handleClick = function (value) {
            var _a = _this.props, disabled = _a.disabled, isMultiple = _a.isMultiple;
            if (disabled) {
                return;
            }
            if (!isMultiple) {
                _this.setCurrentValue(value, function () {
                    var inputDom = _this.getSearchInput();
                    inputDom === null || inputDom === void 0 ? void 0 : inputDom.blur();
                });
                return;
            }
            _this.handleMultipleClick(value);
        };
        _this.handleMultipleClick = function (value) {
            var currentValue = _this.value.slice();
            var idx = currentValue.indexOf(value);
            if (-1 !== idx) {
                currentValue.splice(idx, 1);
            }
            else {
                currentValue.push(value);
            }
            _this.setCurrentValue(currentValue, function () {
                if (_this.props.searchPlacement !== 'dropdown') {
                    _this.setSearchValue('');
                }
            });
        };
        _this.handleVisibleChange = function (visible) {
            if (visible === true) {
                setTimeout(function () { return _this.focusSearchInput(); }, 100);
                _this.scrollToSelected(70);
            }
            var newVisible = visible;
            if (_this.isClickSelect) {
                _this.isClickSelect = false;
                newVisible = true;
            }
            _this.setState({ visible: newVisible });
            _this.props.onVisibleChange(newVisible);
            if (_this.props.showSearch) {
                _this.setSearchValue('');
            }
        };
        _this.handleSearchKeydown = function (event) {
            var _a = _this.props, isMultiple = _a.isMultiple, showSearch = _a.showSearch, searchPlacement = _a.searchPlacement;
            var searchValue = _this.state.searchValue;
            var value = _this.value;
            if (!showSearch
                || (showSearch && searchPlacement === 'dropdown')
                || searchValue
                || !isMultiple
                || !value.length
                || event.key !== 'Backspace') {
                return;
            }
            var values = tslib_1.__spreadArray([], value);
            values.pop();
            _this.setCurrentValue(values, function () {
                _this.updateDropContentMetric();
            });
        };
        _this.handleSearchChange = function (event) {
            var value = event.target.value;
            _this.setSearchValue(value);
        };
        _this.handleOnChange = function (value) {
            _this.setSearchValue(value);
        };
        _this.handleMousedown = function (event) {
            var _a = _this.props, isMultiple = _a.isMultiple, showSearch = _a.showSearch, searchPlacement = _a.searchPlacement;
            isMultiple && showSearch && (searchPlacement === 'select') && event.preventDefault();
        };
        _this.handleSearchFocus = function () {
            _this.setState({
                isSearchFocus: true,
            });
        };
        _this.handleSearchBlur = function () {
            _this.setState({
                isSearchFocus: false,
            });
        };
        _this.focusSearchInput = function () {
            var isSearchFocus = _this.state.isSearchFocus;
            var inputDom = _this.getSearchInput();
            if (isSearchFocus || !inputDom) {
                return;
            }
            inputDom.focus();
        };
        _this.handleDelete = function (value) {
            var isMultiple = _this.props.isMultiple;
            if (!isMultiple) {
                _this.setCurrentValue('');
                return;
            }
            var values = tslib_1.__spreadArray([], _this.value);
            var index = values.findIndex(function (val) { return val === value; });
            if (index === -1) {
                return;
            }
            values.splice(index, 1);
            _this.setCurrentValue(values, function () {
                _this.updateDropContentMetric();
            });
        };
        _this.handleSelectKeydown = function (e) {
            var _a, _b;
            if (_this.isVisible() || _this.props.disabled) {
                return;
            }
            if (['ArrowDown', 'ArrowUp', ' ', 'Enter'].includes(e.key)) {
                e.preventDefault();
                (_b = (_a = e.target).click) === null || _b === void 0 ? void 0 : _b.call(_a);
            }
        };
        _this.searchInputRender = function (classNames) {
            var _a, _b;
            var _c = _this.props, prefixCls = _c.prefixCls, isMultiple = _c.isMultiple, inputClassName = _c.inputClassName, inputStyle = _c.inputStyle;
            var _d = _this.state, searchValue = _d.searchValue, isSearchFocus = _d.isSearchFocus;
            var inputContainerCls = classNames(prefixCls + "-input-container", (_a = {},
                _a[prefixCls + "-input-container-multiple"] = isMultiple,
                _a));
            var inputCls = classNames(prefixCls + "-input", inputClassName, (_b = {},
                _b[prefixCls + "-input-focus"] = isSearchFocus,
                _b[prefixCls + "-input-multiple"] = isMultiple,
                _b));
            return (h("div", { className: inputContainerCls },
                h("input", { style: inputStyle, ref: _this.searchInputRef, className: inputCls, value: searchValue, onFocus: _this.handleSearchFocus, onChange: _this.handleSearchChange, onBlur: _this.handleSearchBlur, onKeyDown: _this.handleSearchKeydown }),
                isMultiple ? h("div", { className: prefixCls + "-input-content-multiple" }, searchValue) : null));
        };
        _this.defaultTagRender = function (tag, handleDelete, classNames) {
            var _a;
            var _b = _this.props, isMultiple = _b.isMultiple, prefixCls = _b.prefixCls, textClassName = _b.textClassName, textStyle = _b.textStyle, optionLabelProp = _b.optionLabelProp;
            var textCls = classNames(prefixCls + "-text", textClassName, (_a = {},
                _a[prefixCls + "-text-multiple"] = isMultiple,
                _a));
            var text = tag[optionLabelProp];
            if (typeof text === 'undefined') {
                console.error("Option's " + optionLabelProp + " is undefined");
            }
            if (!isMultiple) {
                return h("span", { className: textCls, style: textStyle, key: tag.value }, text);
            }
            return (h("span", { className: textCls, style: textStyle, key: tag.value },
                h("span", null, text),
                h("div", { className: prefixCls + "-delete", onClick: handleDelete.bind(_this, tag.value) })));
        };
        _this.themedRender = function (classNames) {
            var _a, _b, _c;
            var _d = _this.props, prefixCls = _d.prefixCls, className = _d.className, style = _d.style, testId = _d.testId, selectDomRef = _d.selectDomRef, containerDom = _d.containerDom, disabled = _d.disabled, dropdownAlignment = _d.dropdownAlignment, dropdownMatchSelectWidth = _d.dropdownMatchSelectWidth, showArrow = _d.showArrow, arrowStyle = _d.arrowStyle, textStyle = _d.textStyle, animated = _d.animated, textContainerTestId = _d.textContainerTestId, arrowClassName = _d.arrowClassName, textClassName = _d.textClassName, zIndex = _d.zIndex, destroyOnClose = _d.destroyOnClose, isMultiple = _d.isMultiple, placeholder = _d.placeholder, customizedTagRender = _d.renderTag, showSearch = _d.showSearch, textContainerStyle = _d.textContainerStyle, textContainerClassName = _d.textContainerClassName, placement = _d.placement, containerClassName = _d.containerClassName, containerStyle = _d.containerStyle, searchPlacement = _d.searchPlacement, viewportMargin = _d.viewportMargin;
            var _e = _this.state, searchValue = _e.searchValue, isSearchFocus = _e.isSearchFocus;
            var cls = classNames(prefixCls, className, (_a = {},
                _a[prefixCls + "-disabled"] = disabled,
                _a[prefixCls + "-multiple"] = isMultiple,
                _a[prefixCls + "-focus"] = isSearchFocus,
                _a[prefixCls + "-search"] = showSearch,
                _a));
            var value = _this.value;
            var values = Array.isArray(value) ? value : [value];
            var tags = _this.getTags(values);
            var tagRender = customizedTagRender ? customizedTagRender : _this.defaultTagRender;
            var visible = _this.isVisible();
            var arrowCls = classNames(prefixCls + "-arrow", arrowClassName, (_b = {},
                _b[prefixCls + "-arrow-visible"] = visible,
                _b[prefixCls + "-arrow-no-animation"] = !animated,
                _b));
            var placeholderCls = classNames(prefixCls + "-text", prefixCls + "-placeholder", textClassName);
            var textContainerCls = classNames(prefixCls + "-text-container", textContainerClassName, (_c = {},
                _c[prefixCls + "-text-container-multiple"] = isMultiple,
                _c));
            var showPlaceholder = ((showSearch && searchPlacement === 'dropdown') || !searchValue) && tags.length === 0;
            return (h(Dropdown_1.default, { dropContent: _this.renderDropContent(values, classNames), alignment: dropdownAlignment, placement: placement, matchWidth: dropdownMatchSelectWidth, disabled: disabled, visible: visible, onVisibleChange: _this.handleVisibleChange, zIndex: zIndex, destroyOnClose: destroyOnClose, ref: _this.dropdownRef, animated: animated, className: containerClassName, style: containerStyle, autoFocus: !showSearch, containerDom: containerDom, viewportMargin: viewportMargin },
                h("div", { className: cls, style: style, onClick: _this.handleSelectClick, role: isMultiple ? 'listbox' : 'combobox', tabIndex: 0, onKeyDown: _this.handleSelectKeydown, "aria-owns": _this.menuId, "aria-activedescendant": isMultiple ? undefined : context_1.getOptionHtmlId(_this.menuId, value), "data-testid": testId, ref: selectDomRef },
                    h("div", { className: textContainerCls, style: textContainerStyle, "data-testid": textContainerTestId },
                        tags.map(function (tag) { return tagRender(tag, _this.handleDelete, classNames); }),
                        (showSearch && searchPlacement === 'select') ? _this.searchInputRender(classNames) : null,
                        showPlaceholder ? h("span", { className: placeholderCls, style: textStyle }, placeholder) : null),
                    showArrow ? h("span", { className: arrowCls, style: arrowStyle, ref: _this.arrowRef }) : null)));
        };
        return _this;
    }
    Select.getDerivedStateFromProps = function (props, state) {
        if (props.disabled) {
            return { visible: false };
        }
        return null;
    };
    Object.defineProperty(Select.prototype, "value", {
        get: function () {
            return this.props.value !== undefined ? this.props.value : this.state.currentValue;
        },
        enumerable: false,
        configurable: true
    });
    Select.prototype.getInitValue = function () {
        var _a = this.props, isMultiple = _a.isMultiple, defaultValue = _a.defaultValue, value = _a.value;
        if (value) {
            return value;
        }
        if (defaultValue) {
            return defaultValue;
        }
        if (isMultiple) {
            return [];
        }
        return '';
    };
    Select.prototype.isVisible = function () {
        var _a = this.props, forceVisible = _a.visible, disabled = _a.disabled;
        if (disabled) {
            return false;
        }
        var stateVisible = this.state.visible;
        return typeof forceVisible === 'boolean' ? forceVisible : stateVisible;
    };
    Select.prototype.scrollToSelected = function (timeout) {
        var _this = this;
        if (timeout === void 0) { timeout = 0; }
        setTimeout(function () {
            var _a;
            (_a = _this.menuRef.current) === null || _a === void 0 ? void 0 : _a.scrollToSelected();
        }, timeout);
    };
    Select.prototype.getSearchInput = function () {
        var showSearch = this.props.showSearch;
        if (!showSearch) {
            return null;
        }
        return this.searchInputRef.current;
    };
    Select.prototype.getChildrenOptions = function () {
        var children = this.props.children;
        return children_1.getElementsInChildren(children, OptionElementType);
    };
    Select.prototype.getTags = function (values) {
        if (!values.length) {
            return [];
        }
        var options = this.getChildrenOptions();
        return values.reduce(function (tags, value) {
            for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
                var child = options_1[_i];
                if (!child) {
                    continue;
                }
                var childProps = child.props;
                if (value === childProps.value) {
                    tags.push(childProps);
                    return tags;
                }
            }
            return tags;
        }, []);
    };
    Select.prototype.getFilteredOptionsBySearch = function (children) {
        var searchValue = this.state.searchValue;
        var filterOption = this.props.filterOption;
        if (!searchValue) {
            return React.Children.toArray(children);
        }
        var defineMatchPriority = false;
        var filteredOptions = [];
        var filteredOptionsByPriority = [];
        this.getChildrenOptions().forEach(function (option) {
            var childProps = option.props;
            var searchRes = filterOption(searchValue, childProps);
            if (typeof searchRes === 'number' && searchRes > 0) {
                defineMatchPriority = true;
                filteredOptionsByPriority.push({
                    priority: searchRes,
                    option: option,
                });
            }
            else {
                searchRes && filteredOptions.push(option);
            }
        });
        if (defineMatchPriority) {
            filteredOptionsByPriority.sort(function (itemA, itemB) { return (itemB.priority - itemA.priority); });
            filteredOptions = filteredOptionsByPriority.map(function (item) { return item.option; });
        }
        return filteredOptions;
    };
    Select.prototype.renderMenuContent = function (options, classNames) {
        var _a = this.props, renderEmptyContent = _a.renderEmptyContent, prefixCls = _a.prefixCls;
        var searchValue = this.state.searchValue;
        var emptyCls = classNames(prefixCls + "-empty-content");
        if (options.length === 0) {
            return renderEmptyContent
                ? renderEmptyContent(searchValue)
                : h("div", { className: emptyCls }, locale_1.i18n('noOptions'));
        }
        return options;
    };
    Select.prototype.renderDropdownSearchInput = function (classNames) {
        var _a = this.props, showSearch = _a.showSearch, inputStyle = _a.inputStyle, inputClassName = _a.inputClassName, searchPlaceholer = _a.searchPlaceholer, searchPlacement = _a.searchPlacement, prefixCls = _a.prefixCls;
        var searchValue = this.state.searchValue;
        var inputCls = classNames(prefixCls + "-search-input", inputClassName);
        var shouldShow = (showSearch && searchPlacement === 'dropdown');
        return shouldShow && (h(Dropdown_1.default.Keep, null,
            h(Input_1.default, { inputRef: this.searchInputRef, style: inputStyle, className: inputCls, placeholder: searchPlaceholer, showClear: true, value: searchValue, onChange: this.handleOnChange, onKeyDown: this.handleSearchKeydown, size: 1 })));
    };
    Select.prototype.renderDropContent = function (values, classNames) {
        var _a, _b;
        var _c = this.props, isMultiple = _c.isMultiple, children = _c.children, prefixCls = _c.prefixCls, showSearch = _c.showSearch, listKeyDownEventDom = _c.listKeyDownEventDom, listClassName = _c.listClassName, listStyle = _c.listStyle, renderDropdown = _c.renderDropdown, searchPlacement = _c.searchPlacement, listContainerClassName = _c.listContainerClassName, listContainerStyle = _c.listContainerStyle, listTestId = _c.listTestId;
        var searchValue = this.state.searchValue;
        var options = this.getFilteredOptionsBySearch(children);
        var content = renderDropdown ? renderDropdown(options, searchValue) : this.renderMenuContent(options, classNames);
        var searchInDropdown = showSearch && searchPlacement === 'dropdown';
        var listCls = classNames(prefixCls + "-list", listClassName, (_a = {},
            _a[prefixCls + "-list-with-search"] = searchInDropdown,
            _a));
        var menuContainerCls = classNames(prefixCls + "-list-container", listContainerClassName, (_b = {},
            _b[prefixCls + "-list-container-with-search"] = searchInDropdown,
            _b));
        return (h(Dropdown_1.default.Keep, { disabled: !isMultiple, onMouseDown: this.handleMousedown, className: menuContainerCls, style: listContainerStyle },
            this.renderDropdownSearchInput(classNames),
            h(Menu_1.default, { className: listCls, style: listStyle, onClick: this.handleClick, selectedIds: values, role: "listbox", "aria-haspopup": false, id: this.menuId, testId: listTestId, keyDownEventDom: listKeyDownEventDom, ref: this.menuRef },
                h(context_1.SelectOptionContext.Provider, { value: context_1.getSelectOptionContext({ isMultiple: isMultiple, parentMenuId: this.menuId }) }, content))));
    };
    Select.prototype.render = function () {
        return theme_1.consumeTheme(this.themedRender);
    };
    return Select;
}(React.Component));
exports.default = Select;
function defaultFilterOption(searchValue, childProps) {
    var children = childProps.children, value = childProps.value;
    var isChildrenMatch = (typeof children === 'string' || typeof children === 'number') && String(children).indexOf(searchValue) !== -1;
    var isValueMatch = String(value).indexOf(searchValue) !== -1;
    return isChildrenMatch || isValueMatch;
}
Select.defaultProps = {
    prefixCls: 'dui-select',
    onChange: helper_1.emptyFn,
    showArrow: true,
    dropdownMatchSelectWidth: true,
    disabled: false,
    dropdownAlignment: 'left',
    placeholder: locale_1.i18n('select'),
    onVisibleChange: helper_1.emptyFn,
    destroyOnClose: true,
    isMultiple: false,
    showSearch: false,
    optionLabelProp: 'children',
    placement: 'auto',
    animated: true,
    searchPlacement: 'select',
    searchPlaceholer: locale_1.i18n('search'),
    filterOption: defaultFilterOption,
};
